"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsStorage = _interopRequireDefault(require("js-storage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TOGGLE STATE
// -----------------------------------
// Handle states to/from localstorage
var StateTogglerStorage = /*#__PURE__*/function () {
  function StateTogglerStorage() {}

  var _proto = StateTogglerStorage.prototype;

  // Add a state to the browser storage to be restored later
  _proto.addState = function addState(classname) {
    var data = _jsStorage.default.localStorage.get(StateTogglerStorage.STORAGE_KEY_NAME);

    if (data instanceof Array) {
      data.push(classname);
    } else {
      data = [classname];
    }

    _jsStorage.default.localStorage.set(StateTogglerStorage.STORAGE_KEY_NAME, data);
  } // Remove a state from the browser storage
  ;

  _proto.removeState = function removeState(classname) {
    var data = _jsStorage.default.localStorage.get(StateTogglerStorage.STORAGE_KEY_NAME);

    if (data) {
      var index = data.indexOf(classname);

      if (index !== -1) {
        data.splice(index, 1);
      }

      _jsStorage.default.localStorage.set(StateTogglerStorage.STORAGE_KEY_NAME, data);
    }
  } // Load the state string and restore the classlist
  ;

  _proto.restoreState = function restoreState(elem) {
    var data = _jsStorage.default.localStorage.get(StateTogglerStorage.STORAGE_KEY_NAME); // console.log(data);


    if (data instanceof Array && data.length) {
      data.forEach(function (item) {
        elem.classList.add(item);
      });
    }
  };

  return StateTogglerStorage;
}();

StateTogglerStorage.STORAGE_KEY_NAME = 'js-toggleState';
StateTogglerStorage.propTypes = {
  onClick: _propTypes.default.func,
  // save the onClick of previous handler
  state: _propTypes.default.string.isRequired,
  // the classname to apply/remove
  nopersist: _propTypes.default.bool,
  // avoid saving state to localstorage
  children: _propTypes.default.element.isRequired // allows only one child element

};

var StateToggler = function StateToggler(props) {
  var target = document.querySelector('body'); // selector where to apply the state

  var classname = props.state; // the classname to apply/remove

  var noPersist = !!props.nopersist; // avoid saving state to localstorage

  var prevClickHandler = props.onClick; // save the onClick of previous handler

  var toggle = new StateTogglerStorage();
  toggle.restoreState(target); // restore body classes on init

  var handleClick = function handleClick(e) {
    if (prevClickHandler) {
      prevClickHandler.call();
    }

    if (e.currentTarget.tagName === 'A' || e.currentTarget.classList.contains('uk-expander')) {
      e.preventDefault();
    }

    if (classname) {
      if (target.classList.contains(classname)) {
        target.classList.remove(classname);

        if (!noPersist) {
          toggle.removeState(classname);
        }
      } else {
        target.classList.add(classname);

        if (!noPersist) {
          toggle.addState(classname);
        }
      }
    }
  };

  return /*#__PURE__*/_react.default.cloneElement(_react.default.Children.only(props.children), {
    onClick: handleClick
  });
};

var _default = StateToggler;
exports.default = _default;